import {
  HttpClientInterface,
  HttpClientParams,
  HttpClientParamsNoBody,
} from '@itk/http-client-interface';
import { Observable, of, switchMap } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';

export class NgDjangoHttpClient implements HttpClientInterface {
  constructor(
    private readonly http: HttpClient,
    public baseURL: string,
    public headerFactory: () => Observable<Record<string, string>>,
  ) {}
  buildUrl(path: string): string {
    return `${this.baseURL}${path}`;
  }

  getHeaders(
    headers?: Record<string, string>,
  ): Observable<Record<string, string>> {
    return headers !== undefined ? of(headers) : this.headerFactory();
  }

  get<T>(params: HttpClientParamsNoBody): Observable<T> {
    return this.getHeaders(params.headers).pipe(
      switchMap((headers) =>
        this.http.get<T>(this.buildUrl(params.url), {
          params: params.queryParams,
          headers,
        }),
      ),
    );
  }

  patch<T, U>(params: HttpClientParams<U>): Observable<T> {
    return this.getHeaders(params.headers).pipe(
      switchMap((headers) =>
        this.http.patch<T>(this.buildUrl(params.url), params.body, {
          params: new HttpParams(params.queryParams),
          headers,
        }),
      ),
    );
  }

  put<T, U>(params: HttpClientParams<U>): Observable<T> {
    return this.getHeaders(params.headers).pipe(
      switchMap((headers) =>
        this.http.put<T>(this.buildUrl(params.url), params.body, {
          params: new HttpParams(params.queryParams),
          headers,
        }),
      ),
    );
  }

  post<T, U>(params: HttpClientParams<U>): Observable<T> {
    return this.getHeaders(params.headers).pipe(
      switchMap((headers) =>
        this.http.post<T>(this.buildUrl(params.url), params.body, {
          params: new HttpParams(params.queryParams),
          headers,
        }),
      ),
    );
  }

  delete<T, U>(params: HttpClientParams<U>): Observable<T> {
    return this.getHeaders(params.headers).pipe(
      switchMap((headers) =>
        this.http.delete<T>(this.buildUrl(params.url), {
          params: new HttpParams(params.queryParams),
          headers,
          body: params.body,
        }),
      ),
    );
  }
}
